// @ts-nocheck
// Generated from src/antlr/formula.g4 by ANTLR 4.13.2
// noinspection ES6UnusedImports,JSUnusedGlobalSymbols,JSUnusedLocalSymbols
import {
  ATN,
  ATNDeserializer,
  CharStream,
  DecisionState,
  DFA,
  Lexer,
  LexerATNSimulator,
  RuleContext,
  PredictionContextCache,
  Token,
} from 'antlr4'
export default class formulaLexer extends Lexer {
  public static readonly COLUMN_ID = 1
  public static readonly NUMBER = 2
  public static readonly STRING = 3
  public static readonly BOOLEAN = 4
  public static readonly WS = 5
  public static readonly AND = 6
  public static readonly OR = 7
  public static readonly NOT = 8
  public static readonly PLUS = 9
  public static readonly MINUS = 10
  public static readonly MULTIPLY = 11
  public static readonly DIVIDE = 12
  public static readonly LEFT_PAREN = 13
  public static readonly RIGHT_PAREN = 14
  public static readonly COMMA = 15
  public static readonly AND_OP = 16
  public static readonly OR_OP = 17
  public static readonly NOT_OP = 18
  public static readonly GT = 19
  public static readonly GTE = 20
  public static readonly LT = 21
  public static readonly LTE = 22
  public static readonly EQ = 23
  public static readonly NOT_EQ = 24
  public static readonly CONTAINS = 25
  public static readonly DOES_NOT_CONTAIN = 26
  public static readonly CONTAINS_ANY = 27
  public static readonly CONTAINS_ALL = 28
  public static readonly DOES_NOT_CONTAIN_ANY = 29
  public static readonly IS_EMPTY = 30
  public static readonly IS_NOT_EMPTY = 31
  public static readonly IN = 32
  public static readonly NOT_IN = 33
  public static readonly IFS = 34
  public static readonly SUMIF = 35
  public static readonly COUNTIF = 36
  public static readonly AVERAGEIF = 37
  public static readonly MAX = 38
  public static readonly MIN = 39
  public static readonly SUM = 40
  public static readonly COUNT = 41
  public static readonly COUNT_DISTINCT = 42
  public static readonly AVERAGE = 43
  public static readonly SUMPRODUCT = 44
  public static readonly CEIL = 45
  public static readonly FLOOR = 46
  public static readonly ROUND = 47
  public static readonly MAXIFS = 48
  public static readonly MINIFS = 49
  public static readonly UPPER = 50
  public static readonly LOWER = 51
  public static readonly TRIM = 52
  public static readonly LEN = 53
  public static readonly CONCAT = 54
  public static readonly LEFT = 55
  public static readonly RIGHT = 56
  public static readonly MID = 57
  public static readonly SUBSTITUTE = 58
  public static readonly DATE = 59
  public static readonly DATEADD = 60
  public static readonly DATEDIFF = 61
  public static readonly YEAR = 62
  public static readonly MONTH = 63
  public static readonly DAY = 64
  public static readonly TODAY = 65
  public static readonly NOW = 66
  public static readonly TO_TEXT = 67
  public static readonly TO_NUMBER = 68
  public static readonly TO_DATE = 69
  public static readonly TRUE = 70
  public static readonly FALSE = 71
  public static readonly INVALID_INPUT = 72
  public static readonly EOF = Token.EOF

  public static readonly channelNames: string[] = ['DEFAULT_TOKEN_CHANNEL', 'HIDDEN']
  public static readonly literalNames: (string | null)[] = [
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    "'+'",
    "'-'",
    "'*'",
    "'/'",
    "'('",
    "')'",
    "','",
    "'&&'",
    "'||'",
    "'!'",
    "'>'",
    "'>='",
    "'<'",
    "'<='",
    "'='",
    "'!='",
  ]
  public static readonly symbolicNames: (string | null)[] = [
    null,
    'COLUMN_ID',
    'NUMBER',
    'STRING',
    'BOOLEAN',
    'WS',
    'AND',
    'OR',
    'NOT',
    'PLUS',
    'MINUS',
    'MULTIPLY',
    'DIVIDE',
    'LEFT_PAREN',
    'RIGHT_PAREN',
    'COMMA',
    'AND_OP',
    'OR_OP',
    'NOT_OP',
    'GT',
    'GTE',
    'LT',
    'LTE',
    'EQ',
    'NOT_EQ',
    'CONTAINS',
    'DOES_NOT_CONTAIN',
    'CONTAINS_ANY',
    'CONTAINS_ALL',
    'DOES_NOT_CONTAIN_ANY',
    'IS_EMPTY',
    'IS_NOT_EMPTY',
    'IN',
    'NOT_IN',
    'IFS',
    'SUMIF',
    'COUNTIF',
    'AVERAGEIF',
    'MAX',
    'MIN',
    'SUM',
    'COUNT',
    'COUNT_DISTINCT',
    'AVERAGE',
    'SUMPRODUCT',
    'CEIL',
    'FLOOR',
    'ROUND',
    'MAXIFS',
    'MINIFS',
    'UPPER',
    'LOWER',
    'TRIM',
    'LEN',
    'CONCAT',
    'LEFT',
    'RIGHT',
    'MID',
    'SUBSTITUTE',
    'DATE',
    'DATEADD',
    'DATEDIFF',
    'YEAR',
    'MONTH',
    'DAY',
    'TODAY',
    'NOW',
    'TO_TEXT',
    'TO_NUMBER',
    'TO_DATE',
    'TRUE',
    'FALSE',
    'INVALID_INPUT',
  ]
  public static readonly modeNames: string[] = ['DEFAULT_MODE']

  public static readonly ruleNames: string[] = [
    'COLUMN_ID',
    'HEX_DIGIT',
    'NUMBER',
    'STRING',
    'BOOLEAN',
    'WS',
    'AND',
    'OR',
    'NOT',
    'PLUS',
    'MINUS',
    'MULTIPLY',
    'DIVIDE',
    'LEFT_PAREN',
    'RIGHT_PAREN',
    'COMMA',
    'AND_OP',
    'OR_OP',
    'NOT_OP',
    'GT',
    'GTE',
    'LT',
    'LTE',
    'EQ',
    'NOT_EQ',
    'CONTAINS',
    'DOES_NOT_CONTAIN',
    'CONTAINS_ANY',
    'CONTAINS_ALL',
    'DOES_NOT_CONTAIN_ANY',
    'IS_EMPTY',
    'IS_NOT_EMPTY',
    'IN',
    'NOT_IN',
    'IFS',
    'SUMIF',
    'COUNTIF',
    'AVERAGEIF',
    'MAX',
    'MIN',
    'SUM',
    'COUNT',
    'COUNT_DISTINCT',
    'AVERAGE',
    'SUMPRODUCT',
    'CEIL',
    'FLOOR',
    'ROUND',
    'MAXIFS',
    'MINIFS',
    'UPPER',
    'LOWER',
    'TRIM',
    'LEN',
    'CONCAT',
    'LEFT',
    'RIGHT',
    'MID',
    'SUBSTITUTE',
    'DATE',
    'DATEADD',
    'DATEDIFF',
    'YEAR',
    'MONTH',
    'DAY',
    'TODAY',
    'NOW',
    'TO_TEXT',
    'TO_NUMBER',
    'TO_DATE',
    'TRUE',
    'FALSE',
    'INVALID_INPUT',
  ]

  constructor(input: CharStream) {
    super(input)
    this._interp = new LexerATNSimulator(
      this,
      formulaLexer._ATN,
      formulaLexer.DecisionsToDFA,
      new PredictionContextCache(),
    )
  }

  public get grammarFileName(): string {
    return 'formula.g4'
  }

  public get literalNames(): (string | null)[] {
    return formulaLexer.literalNames
  }
  public get symbolicNames(): (string | null)[] {
    return formulaLexer.symbolicNames
  }
  public get ruleNames(): string[] {
    return formulaLexer.ruleNames
  }

  public get serializedATN(): number[] {
    return formulaLexer._serializedATN
  }

  public get channelNames(): string[] {
    return formulaLexer.channelNames
  }

  public get modeNames(): string[] {
    return formulaLexer.modeNames
  }

  public static readonly _serializedATN: number[] = [
    4, 0, 72, 649, 6, -1, 2, 0, 7, 0, 2, 1, 7, 1, 2, 2, 7, 2, 2, 3, 7, 3, 2, 4, 7, 4, 2, 5, 7, 5, 2,
    6, 7, 6, 2, 7, 7, 7, 2, 8, 7, 8, 2, 9, 7, 9, 2, 10, 7, 10, 2, 11, 7, 11, 2, 12, 7, 12, 2, 13, 7,
    13, 2, 14, 7, 14, 2, 15, 7, 15, 2, 16, 7, 16, 2, 17, 7, 17, 2, 18, 7, 18, 2, 19, 7, 19, 2, 20,
    7, 20, 2, 21, 7, 21, 2, 22, 7, 22, 2, 23, 7, 23, 2, 24, 7, 24, 2, 25, 7, 25, 2, 26, 7, 26, 2,
    27, 7, 27, 2, 28, 7, 28, 2, 29, 7, 29, 2, 30, 7, 30, 2, 31, 7, 31, 2, 32, 7, 32, 2, 33, 7, 33,
    2, 34, 7, 34, 2, 35, 7, 35, 2, 36, 7, 36, 2, 37, 7, 37, 2, 38, 7, 38, 2, 39, 7, 39, 2, 40, 7,
    40, 2, 41, 7, 41, 2, 42, 7, 42, 2, 43, 7, 43, 2, 44, 7, 44, 2, 45, 7, 45, 2, 46, 7, 46, 2, 47,
    7, 47, 2, 48, 7, 48, 2, 49, 7, 49, 2, 50, 7, 50, 2, 51, 7, 51, 2, 52, 7, 52, 2, 53, 7, 53, 2,
    54, 7, 54, 2, 55, 7, 55, 2, 56, 7, 56, 2, 57, 7, 57, 2, 58, 7, 58, 2, 59, 7, 59, 2, 60, 7, 60,
    2, 61, 7, 61, 2, 62, 7, 62, 2, 63, 7, 63, 2, 64, 7, 64, 2, 65, 7, 65, 2, 66, 7, 66, 2, 67, 7,
    67, 2, 68, 7, 68, 2, 69, 7, 69, 2, 70, 7, 70, 2, 71, 7, 71, 2, 72, 7, 72, 1, 0, 1, 0, 1, 0, 1,
    0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1,
    0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1,
    0, 1, 0, 1, 0, 1, 0, 1, 1, 1, 1, 1, 2, 4, 2, 190, 8, 2, 11, 2, 12, 2, 191, 1, 2, 1, 2, 4, 2,
    196, 8, 2, 11, 2, 12, 2, 197, 3, 2, 200, 8, 2, 1, 3, 1, 3, 1, 3, 1, 3, 5, 3, 206, 8, 3, 10, 3,
    12, 3, 209, 9, 3, 1, 3, 1, 3, 1, 4, 1, 4, 3, 4, 215, 8, 4, 1, 5, 4, 5, 218, 8, 5, 11, 5, 12, 5,
    219, 1, 5, 1, 5, 1, 6, 1, 6, 1, 6, 1, 6, 1, 7, 1, 7, 1, 7, 1, 8, 1, 8, 1, 8, 1, 8, 1, 9, 1, 9,
    1, 10, 1, 10, 1, 11, 1, 11, 1, 12, 1, 12, 1, 13, 1, 13, 1, 14, 1, 14, 1, 15, 1, 15, 1, 16, 1,
    16, 1, 16, 1, 17, 1, 17, 1, 17, 1, 18, 1, 18, 1, 19, 1, 19, 1, 20, 1, 20, 1, 20, 1, 21, 1, 21,
    1, 22, 1, 22, 1, 22, 1, 23, 1, 23, 1, 24, 1, 24, 1, 24, 1, 25, 1, 25, 1, 25, 1, 25, 1, 25, 1,
    25, 1, 25, 1, 25, 1, 25, 1, 26, 1, 26, 1, 26, 1, 26, 1, 26, 3, 26, 286, 8, 26, 1, 26, 1, 26, 1,
    26, 1, 26, 3, 26, 292, 8, 26, 1, 26, 1, 26, 1, 26, 1, 26, 1, 26, 1, 26, 1, 26, 1, 26, 1, 27, 1,
    27, 1, 27, 1, 27, 1, 27, 1, 27, 1, 27, 1, 27, 1, 27, 3, 27, 311, 8, 27, 1, 27, 1, 27, 1, 27, 1,
    27, 1, 28, 1, 28, 1, 28, 1, 28, 1, 28, 1, 28, 1, 28, 1, 28, 1, 28, 3, 28, 326, 8, 28, 1, 28, 1,
    28, 1, 28, 1, 28, 1, 29, 1, 29, 1, 29, 1, 29, 1, 29, 3, 29, 337, 8, 29, 1, 29, 1, 29, 1, 29, 1,
    29, 3, 29, 343, 8, 29, 1, 29, 1, 29, 1, 29, 1, 29, 1, 29, 1, 29, 1, 29, 1, 29, 3, 29, 353, 8,
    29, 1, 29, 1, 29, 1, 29, 1, 29, 1, 30, 1, 30, 1, 30, 3, 30, 362, 8, 30, 1, 30, 1, 30, 1, 30, 1,
    30, 1, 30, 1, 30, 1, 31, 1, 31, 1, 31, 3, 31, 373, 8, 31, 1, 31, 1, 31, 1, 31, 1, 31, 3, 31,
    379, 8, 31, 1, 31, 1, 31, 1, 31, 1, 31, 1, 31, 1, 31, 1, 32, 1, 32, 1, 32, 1, 33, 1, 33, 1, 33,
    1, 33, 3, 33, 394, 8, 33, 1, 33, 1, 33, 1, 33, 1, 34, 1, 34, 1, 34, 1, 34, 1, 35, 1, 35, 1, 35,
    1, 35, 1, 35, 1, 35, 1, 36, 1, 36, 1, 36, 1, 36, 1, 36, 1, 36, 1, 36, 1, 36, 1, 37, 1, 37, 1,
    37, 1, 37, 1, 37, 1, 37, 1, 37, 1, 37, 1, 37, 1, 37, 1, 38, 1, 38, 1, 38, 1, 38, 1, 39, 1, 39,
    1, 39, 1, 39, 1, 40, 1, 40, 1, 40, 1, 40, 1, 41, 1, 41, 1, 41, 1, 41, 1, 41, 1, 41, 1, 42, 1,
    42, 1, 42, 1, 42, 1, 42, 1, 42, 1, 42, 1, 42, 1, 42, 1, 42, 1, 42, 1, 42, 1, 42, 1, 42, 1, 42,
    1, 43, 1, 43, 1, 43, 1, 43, 1, 43, 1, 43, 1, 43, 1, 43, 1, 44, 1, 44, 1, 44, 1, 44, 1, 44, 1,
    44, 1, 44, 1, 44, 1, 44, 1, 44, 1, 44, 1, 45, 1, 45, 1, 45, 1, 45, 1, 45, 1, 46, 1, 46, 1, 46,
    1, 46, 1, 46, 1, 46, 1, 47, 1, 47, 1, 47, 1, 47, 1, 47, 1, 47, 1, 48, 1, 48, 1, 48, 1, 48, 1,
    48, 1, 48, 1, 48, 1, 49, 1, 49, 1, 49, 1, 49, 1, 49, 1, 49, 1, 49, 1, 50, 1, 50, 1, 50, 1, 50,
    1, 50, 1, 50, 1, 51, 1, 51, 1, 51, 1, 51, 1, 51, 1, 51, 1, 52, 1, 52, 1, 52, 1, 52, 1, 52, 1,
    53, 1, 53, 1, 53, 1, 53, 1, 54, 1, 54, 1, 54, 1, 54, 1, 54, 1, 54, 1, 54, 1, 55, 1, 55, 1, 55,
    1, 55, 1, 55, 1, 56, 1, 56, 1, 56, 1, 56, 1, 56, 1, 56, 1, 57, 1, 57, 1, 57, 1, 57, 1, 58, 1,
    58, 1, 58, 1, 58, 1, 58, 1, 58, 1, 58, 1, 58, 1, 58, 1, 58, 1, 58, 1, 59, 1, 59, 1, 59, 1, 59,
    1, 59, 1, 60, 1, 60, 1, 60, 1, 60, 1, 60, 1, 60, 1, 60, 1, 60, 1, 61, 1, 61, 1, 61, 1, 61, 1,
    61, 1, 61, 1, 61, 1, 61, 1, 61, 1, 62, 1, 62, 1, 62, 1, 62, 1, 62, 1, 63, 1, 63, 1, 63, 1, 63,
    1, 63, 1, 63, 1, 64, 1, 64, 1, 64, 1, 64, 1, 65, 1, 65, 1, 65, 1, 65, 1, 65, 1, 65, 1, 66, 1,
    66, 1, 66, 1, 66, 1, 67, 1, 67, 1, 67, 1, 67, 1, 67, 1, 67, 1, 67, 1, 67, 1, 68, 1, 68, 1, 68,
    1, 68, 1, 68, 1, 68, 1, 68, 1, 68, 1, 68, 1, 68, 1, 69, 1, 69, 1, 69, 1, 69, 1, 69, 1, 69, 1,
    69, 1, 69, 1, 70, 1, 70, 1, 70, 1, 70, 1, 70, 1, 71, 1, 71, 1, 71, 1, 71, 1, 71, 1, 71, 1, 72,
    1, 72, 0, 0, 73, 1, 1, 3, 0, 5, 2, 7, 3, 9, 4, 11, 5, 13, 6, 15, 7, 17, 8, 19, 9, 21, 10, 23,
    11, 25, 12, 27, 13, 29, 14, 31, 15, 33, 16, 35, 17, 37, 18, 39, 19, 41, 20, 43, 21, 45, 22, 47,
    23, 49, 24, 51, 25, 53, 26, 55, 27, 57, 28, 59, 29, 61, 30, 63, 31, 65, 32, 67, 33, 69, 34, 71,
    35, 73, 36, 75, 37, 77, 38, 79, 39, 81, 40, 83, 41, 85, 42, 87, 43, 89, 44, 91, 45, 93, 46, 95,
    47, 97, 48, 99, 49, 101, 50, 103, 51, 105, 52, 107, 53, 109, 54, 111, 55, 113, 56, 115, 57, 117,
    58, 119, 59, 121, 60, 123, 61, 125, 62, 127, 63, 129, 64, 131, 65, 133, 66, 135, 67, 137, 68,
    139, 69, 141, 70, 143, 71, 145, 72, 1, 0, 27, 3, 0, 48, 57, 65, 70, 97, 102, 1, 0, 48, 57, 2, 0,
    34, 34, 92, 92, 4, 0, 10, 10, 13, 13, 34, 34, 92, 92, 3, 0, 9, 10, 13, 13, 32, 32, 2, 0, 65, 65,
    97, 97, 2, 0, 78, 78, 110, 110, 2, 0, 68, 68, 100, 100, 2, 0, 79, 79, 111, 111, 2, 0, 82, 82,
    114, 114, 2, 0, 84, 84, 116, 116, 2, 0, 67, 67, 99, 99, 2, 0, 73, 73, 105, 105, 2, 0, 83, 83,
    115, 115, 2, 0, 69, 69, 101, 101, 2, 0, 89, 89, 121, 121, 2, 0, 76, 76, 108, 108, 2, 0, 77, 77,
    109, 109, 2, 0, 80, 80, 112, 112, 2, 0, 70, 70, 102, 102, 2, 0, 85, 85, 117, 117, 2, 0, 86, 86,
    118, 118, 2, 0, 71, 71, 103, 103, 2, 0, 88, 88, 120, 120, 2, 0, 87, 87, 119, 119, 2, 0, 72, 72,
    104, 104, 2, 0, 66, 66, 98, 98, 665, 0, 1, 1, 0, 0, 0, 0, 5, 1, 0, 0, 0, 0, 7, 1, 0, 0, 0, 0, 9,
    1, 0, 0, 0, 0, 11, 1, 0, 0, 0, 0, 13, 1, 0, 0, 0, 0, 15, 1, 0, 0, 0, 0, 17, 1, 0, 0, 0, 0, 19,
    1, 0, 0, 0, 0, 21, 1, 0, 0, 0, 0, 23, 1, 0, 0, 0, 0, 25, 1, 0, 0, 0, 0, 27, 1, 0, 0, 0, 0, 29,
    1, 0, 0, 0, 0, 31, 1, 0, 0, 0, 0, 33, 1, 0, 0, 0, 0, 35, 1, 0, 0, 0, 0, 37, 1, 0, 0, 0, 0, 39,
    1, 0, 0, 0, 0, 41, 1, 0, 0, 0, 0, 43, 1, 0, 0, 0, 0, 45, 1, 0, 0, 0, 0, 47, 1, 0, 0, 0, 0, 49,
    1, 0, 0, 0, 0, 51, 1, 0, 0, 0, 0, 53, 1, 0, 0, 0, 0, 55, 1, 0, 0, 0, 0, 57, 1, 0, 0, 0, 0, 59,
    1, 0, 0, 0, 0, 61, 1, 0, 0, 0, 0, 63, 1, 0, 0, 0, 0, 65, 1, 0, 0, 0, 0, 67, 1, 0, 0, 0, 0, 69,
    1, 0, 0, 0, 0, 71, 1, 0, 0, 0, 0, 73, 1, 0, 0, 0, 0, 75, 1, 0, 0, 0, 0, 77, 1, 0, 0, 0, 0, 79,
    1, 0, 0, 0, 0, 81, 1, 0, 0, 0, 0, 83, 1, 0, 0, 0, 0, 85, 1, 0, 0, 0, 0, 87, 1, 0, 0, 0, 0, 89,
    1, 0, 0, 0, 0, 91, 1, 0, 0, 0, 0, 93, 1, 0, 0, 0, 0, 95, 1, 0, 0, 0, 0, 97, 1, 0, 0, 0, 0, 99,
    1, 0, 0, 0, 0, 101, 1, 0, 0, 0, 0, 103, 1, 0, 0, 0, 0, 105, 1, 0, 0, 0, 0, 107, 1, 0, 0, 0, 0,
    109, 1, 0, 0, 0, 0, 111, 1, 0, 0, 0, 0, 113, 1, 0, 0, 0, 0, 115, 1, 0, 0, 0, 0, 117, 1, 0, 0, 0,
    0, 119, 1, 0, 0, 0, 0, 121, 1, 0, 0, 0, 0, 123, 1, 0, 0, 0, 0, 125, 1, 0, 0, 0, 0, 127, 1, 0, 0,
    0, 0, 129, 1, 0, 0, 0, 0, 131, 1, 0, 0, 0, 0, 133, 1, 0, 0, 0, 0, 135, 1, 0, 0, 0, 0, 137, 1, 0,
    0, 0, 0, 139, 1, 0, 0, 0, 0, 141, 1, 0, 0, 0, 0, 143, 1, 0, 0, 0, 0, 145, 1, 0, 0, 0, 1, 147, 1,
    0, 0, 0, 3, 186, 1, 0, 0, 0, 5, 189, 1, 0, 0, 0, 7, 201, 1, 0, 0, 0, 9, 214, 1, 0, 0, 0, 11,
    217, 1, 0, 0, 0, 13, 223, 1, 0, 0, 0, 15, 227, 1, 0, 0, 0, 17, 230, 1, 0, 0, 0, 19, 234, 1, 0,
    0, 0, 21, 236, 1, 0, 0, 0, 23, 238, 1, 0, 0, 0, 25, 240, 1, 0, 0, 0, 27, 242, 1, 0, 0, 0, 29,
    244, 1, 0, 0, 0, 31, 246, 1, 0, 0, 0, 33, 248, 1, 0, 0, 0, 35, 251, 1, 0, 0, 0, 37, 254, 1, 0,
    0, 0, 39, 256, 1, 0, 0, 0, 41, 258, 1, 0, 0, 0, 43, 261, 1, 0, 0, 0, 45, 263, 1, 0, 0, 0, 47,
    266, 1, 0, 0, 0, 49, 268, 1, 0, 0, 0, 51, 271, 1, 0, 0, 0, 53, 280, 1, 0, 0, 0, 55, 301, 1, 0,
    0, 0, 57, 316, 1, 0, 0, 0, 59, 331, 1, 0, 0, 0, 61, 358, 1, 0, 0, 0, 63, 369, 1, 0, 0, 0, 65,
    386, 1, 0, 0, 0, 67, 389, 1, 0, 0, 0, 69, 398, 1, 0, 0, 0, 71, 402, 1, 0, 0, 0, 73, 408, 1, 0,
    0, 0, 75, 416, 1, 0, 0, 0, 77, 426, 1, 0, 0, 0, 79, 430, 1, 0, 0, 0, 81, 434, 1, 0, 0, 0, 83,
    438, 1, 0, 0, 0, 85, 444, 1, 0, 0, 0, 87, 459, 1, 0, 0, 0, 89, 467, 1, 0, 0, 0, 91, 478, 1, 0,
    0, 0, 93, 483, 1, 0, 0, 0, 95, 489, 1, 0, 0, 0, 97, 495, 1, 0, 0, 0, 99, 502, 1, 0, 0, 0, 101,
    509, 1, 0, 0, 0, 103, 515, 1, 0, 0, 0, 105, 521, 1, 0, 0, 0, 107, 526, 1, 0, 0, 0, 109, 530, 1,
    0, 0, 0, 111, 537, 1, 0, 0, 0, 113, 542, 1, 0, 0, 0, 115, 548, 1, 0, 0, 0, 117, 552, 1, 0, 0, 0,
    119, 563, 1, 0, 0, 0, 121, 568, 1, 0, 0, 0, 123, 576, 1, 0, 0, 0, 125, 585, 1, 0, 0, 0, 127,
    590, 1, 0, 0, 0, 129, 596, 1, 0, 0, 0, 131, 600, 1, 0, 0, 0, 133, 606, 1, 0, 0, 0, 135, 610, 1,
    0, 0, 0, 137, 618, 1, 0, 0, 0, 139, 628, 1, 0, 0, 0, 141, 636, 1, 0, 0, 0, 143, 641, 1, 0, 0, 0,
    145, 647, 1, 0, 0, 0, 147, 148, 5, 123, 0, 0, 148, 149, 3, 3, 1, 0, 149, 150, 3, 3, 1, 0, 150,
    151, 3, 3, 1, 0, 151, 152, 3, 3, 1, 0, 152, 153, 3, 3, 1, 0, 153, 154, 3, 3, 1, 0, 154, 155, 3,
    3, 1, 0, 155, 156, 3, 3, 1, 0, 156, 157, 5, 45, 0, 0, 157, 158, 3, 3, 1, 0, 158, 159, 3, 3, 1,
    0, 159, 160, 3, 3, 1, 0, 160, 161, 3, 3, 1, 0, 161, 162, 5, 45, 0, 0, 162, 163, 3, 3, 1, 0, 163,
    164, 3, 3, 1, 0, 164, 165, 3, 3, 1, 0, 165, 166, 3, 3, 1, 0, 166, 167, 5, 45, 0, 0, 167, 168, 3,
    3, 1, 0, 168, 169, 3, 3, 1, 0, 169, 170, 3, 3, 1, 0, 170, 171, 3, 3, 1, 0, 171, 172, 5, 45, 0,
    0, 172, 173, 3, 3, 1, 0, 173, 174, 3, 3, 1, 0, 174, 175, 3, 3, 1, 0, 175, 176, 3, 3, 1, 0, 176,
    177, 3, 3, 1, 0, 177, 178, 3, 3, 1, 0, 178, 179, 3, 3, 1, 0, 179, 180, 3, 3, 1, 0, 180, 181, 3,
    3, 1, 0, 181, 182, 3, 3, 1, 0, 182, 183, 3, 3, 1, 0, 183, 184, 3, 3, 1, 0, 184, 185, 5, 125, 0,
    0, 185, 2, 1, 0, 0, 0, 186, 187, 7, 0, 0, 0, 187, 4, 1, 0, 0, 0, 188, 190, 7, 1, 0, 0, 189, 188,
    1, 0, 0, 0, 190, 191, 1, 0, 0, 0, 191, 189, 1, 0, 0, 0, 191, 192, 1, 0, 0, 0, 192, 199, 1, 0, 0,
    0, 193, 195, 5, 46, 0, 0, 194, 196, 7, 1, 0, 0, 195, 194, 1, 0, 0, 0, 196, 197, 1, 0, 0, 0, 197,
    195, 1, 0, 0, 0, 197, 198, 1, 0, 0, 0, 198, 200, 1, 0, 0, 0, 199, 193, 1, 0, 0, 0, 199, 200, 1,
    0, 0, 0, 200, 6, 1, 0, 0, 0, 201, 207, 5, 34, 0, 0, 202, 203, 5, 92, 0, 0, 203, 206, 7, 2, 0, 0,
    204, 206, 8, 3, 0, 0, 205, 202, 1, 0, 0, 0, 205, 204, 1, 0, 0, 0, 206, 209, 1, 0, 0, 0, 207,
    205, 1, 0, 0, 0, 207, 208, 1, 0, 0, 0, 208, 210, 1, 0, 0, 0, 209, 207, 1, 0, 0, 0, 210, 211, 5,
    34, 0, 0, 211, 8, 1, 0, 0, 0, 212, 215, 3, 141, 70, 0, 213, 215, 3, 143, 71, 0, 214, 212, 1, 0,
    0, 0, 214, 213, 1, 0, 0, 0, 215, 10, 1, 0, 0, 0, 216, 218, 7, 4, 0, 0, 217, 216, 1, 0, 0, 0,
    218, 219, 1, 0, 0, 0, 219, 217, 1, 0, 0, 0, 219, 220, 1, 0, 0, 0, 220, 221, 1, 0, 0, 0, 221,
    222, 6, 5, 0, 0, 222, 12, 1, 0, 0, 0, 223, 224, 7, 5, 0, 0, 224, 225, 7, 6, 0, 0, 225, 226, 7,
    7, 0, 0, 226, 14, 1, 0, 0, 0, 227, 228, 7, 8, 0, 0, 228, 229, 7, 9, 0, 0, 229, 16, 1, 0, 0, 0,
    230, 231, 7, 6, 0, 0, 231, 232, 7, 8, 0, 0, 232, 233, 7, 10, 0, 0, 233, 18, 1, 0, 0, 0, 234,
    235, 5, 43, 0, 0, 235, 20, 1, 0, 0, 0, 236, 237, 5, 45, 0, 0, 237, 22, 1, 0, 0, 0, 238, 239, 5,
    42, 0, 0, 239, 24, 1, 0, 0, 0, 240, 241, 5, 47, 0, 0, 241, 26, 1, 0, 0, 0, 242, 243, 5, 40, 0,
    0, 243, 28, 1, 0, 0, 0, 244, 245, 5, 41, 0, 0, 245, 30, 1, 0, 0, 0, 246, 247, 5, 44, 0, 0, 247,
    32, 1, 0, 0, 0, 248, 249, 5, 38, 0, 0, 249, 250, 5, 38, 0, 0, 250, 34, 1, 0, 0, 0, 251, 252, 5,
    124, 0, 0, 252, 253, 5, 124, 0, 0, 253, 36, 1, 0, 0, 0, 254, 255, 5, 33, 0, 0, 255, 38, 1, 0, 0,
    0, 256, 257, 5, 62, 0, 0, 257, 40, 1, 0, 0, 0, 258, 259, 5, 62, 0, 0, 259, 260, 5, 61, 0, 0,
    260, 42, 1, 0, 0, 0, 261, 262, 5, 60, 0, 0, 262, 44, 1, 0, 0, 0, 263, 264, 5, 60, 0, 0, 264,
    265, 5, 61, 0, 0, 265, 46, 1, 0, 0, 0, 266, 267, 5, 61, 0, 0, 267, 48, 1, 0, 0, 0, 268, 269, 5,
    33, 0, 0, 269, 270, 5, 61, 0, 0, 270, 50, 1, 0, 0, 0, 271, 272, 7, 11, 0, 0, 272, 273, 7, 8, 0,
    0, 273, 274, 7, 6, 0, 0, 274, 275, 7, 10, 0, 0, 275, 276, 7, 5, 0, 0, 276, 277, 7, 12, 0, 0,
    277, 278, 7, 6, 0, 0, 278, 279, 7, 13, 0, 0, 279, 52, 1, 0, 0, 0, 280, 281, 7, 7, 0, 0, 281,
    282, 7, 8, 0, 0, 282, 283, 7, 14, 0, 0, 283, 285, 7, 13, 0, 0, 284, 286, 5, 32, 0, 0, 285, 284,
    1, 0, 0, 0, 285, 286, 1, 0, 0, 0, 286, 287, 1, 0, 0, 0, 287, 288, 7, 6, 0, 0, 288, 289, 7, 8, 0,
    0, 289, 291, 7, 10, 0, 0, 290, 292, 5, 32, 0, 0, 291, 290, 1, 0, 0, 0, 291, 292, 1, 0, 0, 0,
    292, 293, 1, 0, 0, 0, 293, 294, 7, 11, 0, 0, 294, 295, 7, 8, 0, 0, 295, 296, 7, 6, 0, 0, 296,
    297, 7, 10, 0, 0, 297, 298, 7, 5, 0, 0, 298, 299, 7, 12, 0, 0, 299, 300, 7, 6, 0, 0, 300, 54, 1,
    0, 0, 0, 301, 302, 7, 11, 0, 0, 302, 303, 7, 8, 0, 0, 303, 304, 7, 6, 0, 0, 304, 305, 7, 10, 0,
    0, 305, 306, 7, 5, 0, 0, 306, 307, 7, 12, 0, 0, 307, 308, 7, 6, 0, 0, 308, 310, 7, 13, 0, 0,
    309, 311, 5, 32, 0, 0, 310, 309, 1, 0, 0, 0, 310, 311, 1, 0, 0, 0, 311, 312, 1, 0, 0, 0, 312,
    313, 7, 5, 0, 0, 313, 314, 7, 6, 0, 0, 314, 315, 7, 15, 0, 0, 315, 56, 1, 0, 0, 0, 316, 317, 7,
    11, 0, 0, 317, 318, 7, 8, 0, 0, 318, 319, 7, 6, 0, 0, 319, 320, 7, 10, 0, 0, 320, 321, 7, 5, 0,
    0, 321, 322, 7, 12, 0, 0, 322, 323, 7, 6, 0, 0, 323, 325, 7, 13, 0, 0, 324, 326, 5, 32, 0, 0,
    325, 324, 1, 0, 0, 0, 325, 326, 1, 0, 0, 0, 326, 327, 1, 0, 0, 0, 327, 328, 7, 5, 0, 0, 328,
    329, 7, 16, 0, 0, 329, 330, 7, 16, 0, 0, 330, 58, 1, 0, 0, 0, 331, 332, 7, 7, 0, 0, 332, 333, 7,
    8, 0, 0, 333, 334, 7, 14, 0, 0, 334, 336, 7, 13, 0, 0, 335, 337, 5, 32, 0, 0, 336, 335, 1, 0, 0,
    0, 336, 337, 1, 0, 0, 0, 337, 338, 1, 0, 0, 0, 338, 339, 7, 6, 0, 0, 339, 340, 7, 8, 0, 0, 340,
    342, 7, 10, 0, 0, 341, 343, 5, 32, 0, 0, 342, 341, 1, 0, 0, 0, 342, 343, 1, 0, 0, 0, 343, 344,
    1, 0, 0, 0, 344, 345, 7, 11, 0, 0, 345, 346, 7, 8, 0, 0, 346, 347, 7, 6, 0, 0, 347, 348, 7, 10,
    0, 0, 348, 349, 7, 5, 0, 0, 349, 350, 7, 12, 0, 0, 350, 352, 7, 6, 0, 0, 351, 353, 5, 32, 0, 0,
    352, 351, 1, 0, 0, 0, 352, 353, 1, 0, 0, 0, 353, 354, 1, 0, 0, 0, 354, 355, 7, 5, 0, 0, 355,
    356, 7, 6, 0, 0, 356, 357, 7, 15, 0, 0, 357, 60, 1, 0, 0, 0, 358, 359, 7, 12, 0, 0, 359, 361, 7,
    13, 0, 0, 360, 362, 5, 32, 0, 0, 361, 360, 1, 0, 0, 0, 361, 362, 1, 0, 0, 0, 362, 363, 1, 0, 0,
    0, 363, 364, 7, 14, 0, 0, 364, 365, 7, 17, 0, 0, 365, 366, 7, 18, 0, 0, 366, 367, 7, 10, 0, 0,
    367, 368, 7, 15, 0, 0, 368, 62, 1, 0, 0, 0, 369, 370, 7, 12, 0, 0, 370, 372, 7, 13, 0, 0, 371,
    373, 5, 32, 0, 0, 372, 371, 1, 0, 0, 0, 372, 373, 1, 0, 0, 0, 373, 374, 1, 0, 0, 0, 374, 375, 7,
    6, 0, 0, 375, 376, 7, 8, 0, 0, 376, 378, 7, 10, 0, 0, 377, 379, 5, 32, 0, 0, 378, 377, 1, 0, 0,
    0, 378, 379, 1, 0, 0, 0, 379, 380, 1, 0, 0, 0, 380, 381, 7, 14, 0, 0, 381, 382, 7, 17, 0, 0,
    382, 383, 7, 18, 0, 0, 383, 384, 7, 10, 0, 0, 384, 385, 7, 15, 0, 0, 385, 64, 1, 0, 0, 0, 386,
    387, 7, 12, 0, 0, 387, 388, 7, 6, 0, 0, 388, 66, 1, 0, 0, 0, 389, 390, 7, 6, 0, 0, 390, 391, 7,
    8, 0, 0, 391, 393, 7, 10, 0, 0, 392, 394, 5, 32, 0, 0, 393, 392, 1, 0, 0, 0, 393, 394, 1, 0, 0,
    0, 394, 395, 1, 0, 0, 0, 395, 396, 7, 12, 0, 0, 396, 397, 7, 6, 0, 0, 397, 68, 1, 0, 0, 0, 398,
    399, 7, 12, 0, 0, 399, 400, 7, 19, 0, 0, 400, 401, 7, 13, 0, 0, 401, 70, 1, 0, 0, 0, 402, 403,
    7, 13, 0, 0, 403, 404, 7, 20, 0, 0, 404, 405, 7, 17, 0, 0, 405, 406, 7, 12, 0, 0, 406, 407, 7,
    19, 0, 0, 407, 72, 1, 0, 0, 0, 408, 409, 7, 11, 0, 0, 409, 410, 7, 8, 0, 0, 410, 411, 7, 20, 0,
    0, 411, 412, 7, 6, 0, 0, 412, 413, 7, 10, 0, 0, 413, 414, 7, 12, 0, 0, 414, 415, 7, 19, 0, 0,
    415, 74, 1, 0, 0, 0, 416, 417, 7, 5, 0, 0, 417, 418, 7, 21, 0, 0, 418, 419, 7, 14, 0, 0, 419,
    420, 7, 9, 0, 0, 420, 421, 7, 5, 0, 0, 421, 422, 7, 22, 0, 0, 422, 423, 7, 14, 0, 0, 423, 424,
    7, 12, 0, 0, 424, 425, 7, 19, 0, 0, 425, 76, 1, 0, 0, 0, 426, 427, 7, 17, 0, 0, 427, 428, 7, 5,
    0, 0, 428, 429, 7, 23, 0, 0, 429, 78, 1, 0, 0, 0, 430, 431, 7, 17, 0, 0, 431, 432, 7, 12, 0, 0,
    432, 433, 7, 6, 0, 0, 433, 80, 1, 0, 0, 0, 434, 435, 7, 13, 0, 0, 435, 436, 7, 20, 0, 0, 436,
    437, 7, 17, 0, 0, 437, 82, 1, 0, 0, 0, 438, 439, 7, 11, 0, 0, 439, 440, 7, 8, 0, 0, 440, 441, 7,
    20, 0, 0, 441, 442, 7, 6, 0, 0, 442, 443, 7, 10, 0, 0, 443, 84, 1, 0, 0, 0, 444, 445, 7, 11, 0,
    0, 445, 446, 7, 8, 0, 0, 446, 447, 7, 20, 0, 0, 447, 448, 7, 6, 0, 0, 448, 449, 7, 10, 0, 0,
    449, 450, 5, 95, 0, 0, 450, 451, 7, 7, 0, 0, 451, 452, 7, 12, 0, 0, 452, 453, 7, 13, 0, 0, 453,
    454, 7, 10, 0, 0, 454, 455, 7, 12, 0, 0, 455, 456, 7, 6, 0, 0, 456, 457, 7, 11, 0, 0, 457, 458,
    7, 10, 0, 0, 458, 86, 1, 0, 0, 0, 459, 460, 7, 5, 0, 0, 460, 461, 7, 21, 0, 0, 461, 462, 7, 14,
    0, 0, 462, 463, 7, 9, 0, 0, 463, 464, 7, 5, 0, 0, 464, 465, 7, 22, 0, 0, 465, 466, 7, 14, 0, 0,
    466, 88, 1, 0, 0, 0, 467, 468, 7, 13, 0, 0, 468, 469, 7, 20, 0, 0, 469, 470, 7, 17, 0, 0, 470,
    471, 7, 18, 0, 0, 471, 472, 7, 9, 0, 0, 472, 473, 7, 8, 0, 0, 473, 474, 7, 7, 0, 0, 474, 475, 7,
    20, 0, 0, 475, 476, 7, 11, 0, 0, 476, 477, 7, 10, 0, 0, 477, 90, 1, 0, 0, 0, 478, 479, 7, 11, 0,
    0, 479, 480, 7, 14, 0, 0, 480, 481, 7, 12, 0, 0, 481, 482, 7, 16, 0, 0, 482, 92, 1, 0, 0, 0,
    483, 484, 7, 19, 0, 0, 484, 485, 7, 16, 0, 0, 485, 486, 7, 8, 0, 0, 486, 487, 7, 8, 0, 0, 487,
    488, 7, 9, 0, 0, 488, 94, 1, 0, 0, 0, 489, 490, 7, 9, 0, 0, 490, 491, 7, 8, 0, 0, 491, 492, 7,
    20, 0, 0, 492, 493, 7, 6, 0, 0, 493, 494, 7, 7, 0, 0, 494, 96, 1, 0, 0, 0, 495, 496, 7, 17, 0,
    0, 496, 497, 7, 5, 0, 0, 497, 498, 7, 23, 0, 0, 498, 499, 7, 12, 0, 0, 499, 500, 7, 19, 0, 0,
    500, 501, 7, 13, 0, 0, 501, 98, 1, 0, 0, 0, 502, 503, 7, 17, 0, 0, 503, 504, 7, 12, 0, 0, 504,
    505, 7, 6, 0, 0, 505, 506, 7, 12, 0, 0, 506, 507, 7, 19, 0, 0, 507, 508, 7, 13, 0, 0, 508, 100,
    1, 0, 0, 0, 509, 510, 7, 20, 0, 0, 510, 511, 7, 18, 0, 0, 511, 512, 7, 18, 0, 0, 512, 513, 7,
    14, 0, 0, 513, 514, 7, 9, 0, 0, 514, 102, 1, 0, 0, 0, 515, 516, 7, 16, 0, 0, 516, 517, 7, 8, 0,
    0, 517, 518, 7, 24, 0, 0, 518, 519, 7, 14, 0, 0, 519, 520, 7, 9, 0, 0, 520, 104, 1, 0, 0, 0,
    521, 522, 7, 10, 0, 0, 522, 523, 7, 9, 0, 0, 523, 524, 7, 12, 0, 0, 524, 525, 7, 17, 0, 0, 525,
    106, 1, 0, 0, 0, 526, 527, 7, 16, 0, 0, 527, 528, 7, 14, 0, 0, 528, 529, 7, 6, 0, 0, 529, 108,
    1, 0, 0, 0, 530, 531, 7, 11, 0, 0, 531, 532, 7, 8, 0, 0, 532, 533, 7, 6, 0, 0, 533, 534, 7, 11,
    0, 0, 534, 535, 7, 5, 0, 0, 535, 536, 7, 10, 0, 0, 536, 110, 1, 0, 0, 0, 537, 538, 7, 16, 0, 0,
    538, 539, 7, 14, 0, 0, 539, 540, 7, 19, 0, 0, 540, 541, 7, 10, 0, 0, 541, 112, 1, 0, 0, 0, 542,
    543, 7, 9, 0, 0, 543, 544, 7, 12, 0, 0, 544, 545, 7, 22, 0, 0, 545, 546, 7, 25, 0, 0, 546, 547,
    7, 10, 0, 0, 547, 114, 1, 0, 0, 0, 548, 549, 7, 17, 0, 0, 549, 550, 7, 12, 0, 0, 550, 551, 7, 7,
    0, 0, 551, 116, 1, 0, 0, 0, 552, 553, 7, 13, 0, 0, 553, 554, 7, 20, 0, 0, 554, 555, 7, 26, 0, 0,
    555, 556, 7, 13, 0, 0, 556, 557, 7, 10, 0, 0, 557, 558, 7, 12, 0, 0, 558, 559, 7, 10, 0, 0, 559,
    560, 7, 20, 0, 0, 560, 561, 7, 10, 0, 0, 561, 562, 7, 14, 0, 0, 562, 118, 1, 0, 0, 0, 563, 564,
    7, 7, 0, 0, 564, 565, 7, 5, 0, 0, 565, 566, 7, 10, 0, 0, 566, 567, 7, 14, 0, 0, 567, 120, 1, 0,
    0, 0, 568, 569, 7, 7, 0, 0, 569, 570, 7, 5, 0, 0, 570, 571, 7, 10, 0, 0, 571, 572, 7, 14, 0, 0,
    572, 573, 7, 5, 0, 0, 573, 574, 7, 7, 0, 0, 574, 575, 7, 7, 0, 0, 575, 122, 1, 0, 0, 0, 576,
    577, 7, 7, 0, 0, 577, 578, 7, 5, 0, 0, 578, 579, 7, 10, 0, 0, 579, 580, 7, 14, 0, 0, 580, 581,
    7, 7, 0, 0, 581, 582, 7, 12, 0, 0, 582, 583, 7, 19, 0, 0, 583, 584, 7, 19, 0, 0, 584, 124, 1, 0,
    0, 0, 585, 586, 7, 15, 0, 0, 586, 587, 7, 14, 0, 0, 587, 588, 7, 5, 0, 0, 588, 589, 7, 9, 0, 0,
    589, 126, 1, 0, 0, 0, 590, 591, 7, 17, 0, 0, 591, 592, 7, 8, 0, 0, 592, 593, 7, 6, 0, 0, 593,
    594, 7, 10, 0, 0, 594, 595, 7, 25, 0, 0, 595, 128, 1, 0, 0, 0, 596, 597, 7, 7, 0, 0, 597, 598,
    7, 5, 0, 0, 598, 599, 7, 15, 0, 0, 599, 130, 1, 0, 0, 0, 600, 601, 7, 10, 0, 0, 601, 602, 7, 8,
    0, 0, 602, 603, 7, 7, 0, 0, 603, 604, 7, 5, 0, 0, 604, 605, 7, 15, 0, 0, 605, 132, 1, 0, 0, 0,
    606, 607, 7, 6, 0, 0, 607, 608, 7, 8, 0, 0, 608, 609, 7, 24, 0, 0, 609, 134, 1, 0, 0, 0, 610,
    611, 7, 10, 0, 0, 611, 612, 7, 8, 0, 0, 612, 613, 5, 95, 0, 0, 613, 614, 7, 10, 0, 0, 614, 615,
    7, 14, 0, 0, 615, 616, 7, 23, 0, 0, 616, 617, 7, 10, 0, 0, 617, 136, 1, 0, 0, 0, 618, 619, 7,
    10, 0, 0, 619, 620, 7, 8, 0, 0, 620, 621, 5, 95, 0, 0, 621, 622, 7, 6, 0, 0, 622, 623, 7, 20, 0,
    0, 623, 624, 7, 17, 0, 0, 624, 625, 7, 26, 0, 0, 625, 626, 7, 14, 0, 0, 626, 627, 7, 9, 0, 0,
    627, 138, 1, 0, 0, 0, 628, 629, 7, 10, 0, 0, 629, 630, 7, 8, 0, 0, 630, 631, 5, 95, 0, 0, 631,
    632, 7, 7, 0, 0, 632, 633, 7, 5, 0, 0, 633, 634, 7, 10, 0, 0, 634, 635, 7, 14, 0, 0, 635, 140,
    1, 0, 0, 0, 636, 637, 7, 10, 0, 0, 637, 638, 7, 9, 0, 0, 638, 639, 7, 20, 0, 0, 639, 640, 7, 14,
    0, 0, 640, 142, 1, 0, 0, 0, 641, 642, 7, 19, 0, 0, 642, 643, 7, 5, 0, 0, 643, 644, 7, 16, 0, 0,
    644, 645, 7, 13, 0, 0, 645, 646, 7, 14, 0, 0, 646, 144, 1, 0, 0, 0, 647, 648, 9, 0, 0, 0, 648,
    146, 1, 0, 0, 0, 19, 0, 191, 197, 199, 205, 207, 214, 219, 285, 291, 310, 325, 336, 342, 352,
    361, 372, 378, 393, 1, 6, 0, 0,
  ]

  private static __ATN: ATN
  public static get _ATN(): ATN {
    if (!formulaLexer.__ATN) {
      formulaLexer.__ATN = new ATNDeserializer().deserialize(formulaLexer._serializedATN)
    }

    return formulaLexer.__ATN
  }

  static DecisionsToDFA = formulaLexer._ATN.decisionToState.map(
    (ds: DecisionState, index: number) => new DFA(ds, index),
  )
}
